import { DEFAULT_CATALOG_VIEW } from "@redotech/redo-inventory-common/views/default-catalog-products-views";
import {
  PermissionedRouteObject,
  PermissionHandle,
} from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { BreadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { defaultChildRoute } from "./legacy-redirects";

export function createCatalogProductsRoute({
  catalogProductsViewBreadcrumb,
  productDetailBreadcrumb,
  productFamilyDetailBreadcrumb,
  showProductModal,
  listPermission,
}: {
  catalogProductsViewBreadcrumb: BreadcrumbSlot;
  productDetailBreadcrumb: BreadcrumbSlot;
  productFamilyDetailBreadcrumb: BreadcrumbSlot;
  showProductModal: boolean;
  /** Gates only the products list; product and family pages stay reachable. */
  listPermission?: PermissionHandle;
}): PermissionedRouteObject {
  return {
    path: "products",
    handle: { breadcrumb: "Products" },
    children: [
      defaultChildRoute(DEFAULT_CATALOG_VIEW),
      {
        path: ":viewName",
        handle: { breadcrumb: catalogProductsViewBreadcrumb },
        async lazy() {
          const { CatalogProductsWrapper } =
            await import("@redotech/redo-merchant-catalog-app/catalog/catalog-products-wrapper");
          if (showProductModal) {
            const { CatalogViewProductModalHost } =
              await import("@redotech/redo-merchant-catalog-app/catalog/catalog-product-modal");
            return {
              element: (
                <>
                  <CatalogProductsWrapper
                    breadcrumb={catalogProductsViewBreadcrumb}
                    productBreadcrumb={productDetailBreadcrumb}
                    productFamilyBreadcrumb={productFamilyDetailBreadcrumb}
                  />
                  <CatalogViewProductModalHost />
                </>
              ),
            };
          }
          return {
            element: (
              <CatalogProductsWrapper
                breadcrumb={catalogProductsViewBreadcrumb}
                productBreadcrumb={productDetailBreadcrumb}
                productFamilyBreadcrumb={productFamilyDetailBreadcrumb}
              />
            ),
          };
        },
        children: [
          {
            index: true,
            handle: { permission: listPermission },
            async lazy() {
              const { CatalogProducts } =
                await import("@redotech/redo-merchant-catalog-app/catalog/catalog-products");
              return { Component: CatalogProducts };
            },
          },
          {
            path: ":productFamilyId",
            handle: { breadcrumb: productFamilyDetailBreadcrumb },
            children: [
              {
                index: true,
                async lazy() {
                  const { ProductFamilyView } =
                    await import("@redotech/redo-merchant-inventory-app/product-families/product-family-view");
                  return { Component: ProductFamilyView };
                },
              },
              {
                path: ":productId",
                handle: { breadcrumb: productDetailBreadcrumb },
                children: [
                  {
                    index: true,
                    async lazy() {
                      const { ProductView } =
                        await import("@redotech/redo-merchant-inventory-app/products/product-view");
                      return { Component: ProductView };
                    },
                  },
                  {
                    path: "locations/:locationId",
                    handle: { breadcrumb: "Adjustment history" },
                    async lazy() {
                      const { ProductLocationHistory } =
                        await import("@redotech/redo-merchant-inventory-app/adjustment-history/product-location-history");
                      return { Component: ProductLocationHistory };
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
}
